<template>
  <b-tab :title-item-class="titleItemClass" :disabled="disabled" @click="$emit('tabClick', tabName)">
    <template #title>
      <slot name="title"></slot>
    </template>

    <slot></slot>
  </b-tab>
</template>

<script>
export default {
  name: "ClienteRuralTabItem",
  props: {
    disabled: Boolean,
    titleItemClass: {
      type: String,
      default: "mb-0"
    },
    tabName: String
  }
};
</script>